export const darkTheme = {
    background: "hsl(207, 26%, 17%)",
    elementbg: "hsl(209, 23%, 22%)",
    text: "hsl(0, 0%, 100%)",
    togglebg: "hsl(209, 23%, 22%)"
};

export const lightTheme = {
    background: "hsl(0, 0%, 98%)",
    elementbg: "hsl(0, 0%, 100%)",
    text: "hsl(200, 15%, 8%)",
    togglebg: "hsl(0, 0%, 100%)"
};